module.exports = __webpack_public_path__ + "media/images/icons/checkmark-6ccb5921f5d1d700ed9a8844994c1014.svg";